// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL Reports API (nestjs)
 * API for reports in WL
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { SpellingByStudentIssueDateResponseDto } from './SpellingByStudentIssueDateResponseDto'
import {
  SpellingByStudentIssueDateResponseDtoFromJSON,
  SpellingByStudentIssueDateResponseDtoFromJSONTyped,
  SpellingByStudentIssueDateResponseDtoToJSON,
} from './SpellingByStudentIssueDateResponseDto'

/**
 *
 * @export
 * @interface SchoolsControllerGetSpellingByStudentIssueDate200Response
 */
export interface SchoolsControllerGetSpellingByStudentIssueDate200Response {
  /**
   *
   * @type {Array<SpellingByStudentIssueDateResponseDto>}
   * @memberof SchoolsControllerGetSpellingByStudentIssueDate200Response
   */
  data: Array<SpellingByStudentIssueDateResponseDto>
  /**
   *
   * @type {number}
   * @memberof SchoolsControllerGetSpellingByStudentIssueDate200Response
   */
  total: number
  /**
   *
   * @type {number}
   * @memberof SchoolsControllerGetSpellingByStudentIssueDate200Response
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof SchoolsControllerGetSpellingByStudentIssueDate200Response
   */
  itemsPerPage: number
  /**
   * Additional metadata
   * @type {object}
   * @memberof SchoolsControllerGetSpellingByStudentIssueDate200Response
   */
  meta?: object
}

/**
 * Check if a given object implements the SchoolsControllerGetSpellingByStudentIssueDate200Response interface.
 */
export function instanceOfSchoolsControllerGetSpellingByStudentIssueDate200Response(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'data' in value
  isInstance = isInstance && 'total' in value
  isInstance = isInstance && 'page' in value
  isInstance = isInstance && 'itemsPerPage' in value

  return isInstance
}

export function SchoolsControllerGetSpellingByStudentIssueDate200ResponseFromJSON(
  json: any,
): SchoolsControllerGetSpellingByStudentIssueDate200Response {
  return SchoolsControllerGetSpellingByStudentIssueDate200ResponseFromJSONTyped(
    json,
    false,
  )
}

export function SchoolsControllerGetSpellingByStudentIssueDate200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SchoolsControllerGetSpellingByStudentIssueDate200Response {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(
      SpellingByStudentIssueDateResponseDtoFromJSON,
    ),
    total: json['total'],
    page: json['page'],
    itemsPerPage: json['itemsPerPage'],
    meta: !exists(json, 'meta') ? undefined : json['meta'],
  }
}

export function SchoolsControllerGetSpellingByStudentIssueDate200ResponseToJSON(
  value?: SchoolsControllerGetSpellingByStudentIssueDate200Response | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(
      SpellingByStudentIssueDateResponseDtoToJSON,
    ),
    total: value.total,
    page: value.page,
    itemsPerPage: value.itemsPerPage,
    meta: value.meta,
  }
}
